var _defs, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b18102a99a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.4375 7.5 L 54.9375 7.5 L 54.9375 60 L 20.4375 60 Z M 20.4375 7.5 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "#ffffff",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -7.5,
    width: 90,
    fill: "#ffffff",
    y: -7.5,
    height: 89.999996,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b18102a99a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002850",
    d: "M 49.792969 19.785156 L 46.75 19.785156 L 46.75 11.460938 C 46.75 9.285156 44.980469 7.519531 42.808594 7.519531 L 32.183594 7.519531 C 30.011719 7.519531 28.242188 9.285156 28.242188 11.460938 L 28.242188 19.785156 L 25.199219 19.785156 C 22.574219 19.785156 20.441406 21.917969 20.441406 24.542969 L 20.441406 50.535156 C 20.441406 52.867188 22.128906 54.808594 24.347656 55.210938 L 24.347656 57.792969 C 24.347656 58.976562 25.308594 59.9375 26.492188 59.9375 L 30.429688 59.9375 C 31.613281 59.9375 32.578125 58.976562 32.578125 57.792969 L 32.578125 55.292969 L 42.417969 55.292969 L 42.417969 57.792969 C 42.417969 58.976562 43.378906 59.9375 44.5625 59.9375 L 48.5 59.9375 C 49.683594 59.9375 50.644531 58.976562 50.644531 57.792969 L 50.644531 55.210938 C 52.863281 54.808594 54.550781 52.867188 54.550781 50.535156 L 54.550781 24.542969 C 54.550781 21.917969 52.417969 19.785156 49.792969 19.785156 Z M 30.871094 11.460938 C 30.871094 10.734375 31.460938 10.144531 32.183594 10.144531 L 42.808594 10.144531 C 43.53125 10.144531 44.121094 10.734375 44.121094 11.460938 L 44.121094 19.785156 L 30.871094 19.785156 Z M 29.949219 57.308594 L 26.976562 57.308594 L 26.976562 55.292969 L 29.949219 55.292969 Z M 45.042969 57.308594 L 45.042969 55.292969 L 48.019531 55.292969 L 48.019531 57.308594 Z M 51.921875 50.535156 C 51.921875 51.707031 50.96875 52.664062 49.792969 52.664062 L 25.199219 52.664062 C 24.023438 52.664062 23.070312 51.707031 23.070312 50.535156 L 23.070312 24.542969 C 23.070312 23.367188 24.023438 22.414062 25.199219 22.414062 L 49.792969 22.414062 C 50.96875 22.414062 51.921875 23.367188 51.921875 24.542969 Z M 51.921875 50.535156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.33e4747066eb0bb373e6fe2e36c3b638.svg";
export { ForwardRef as ReactComponent };